import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PostHeader = ({ post, onFollowToggle, isFollowing }) => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate('/user-profile');
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="sticky top-0 bg-card border-b border-border z-20">
      <div className="flex items-center justify-between p-4 md:p-6">
        <div className="flex items-center gap-3 md:gap-4 flex-1 min-w-0">
          <button
            onClick={handleBackClick}
            className="touch-target flex items-center justify-center text-muted-foreground hover:text-foreground transition-base"
            aria-label="Go back"
          >
            <Icon name="ArrowLeft" size={24} />
          </button>

          <button
            onClick={handleProfileClick}
            className="flex items-center gap-3 min-w-0 flex-1"
            aria-label={`View ${post?.author}'s profile`}
          >
            <div className="relative flex-shrink-0">
              <Image
                src={post?.authorAvatar}
                alt={post?.authorAvatarAlt}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
              />
              {post?.isVerified && (
                <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-primary rounded-full flex items-center justify-center border-2 border-card">
                  <Icon name="Check" size={12} color="white" strokeWidth={3} />
                </div>
              )}
            </div>

            <div className="min-w-0 flex-1 text-left">
              <div className="flex items-center gap-2">
                <h2 className="font-semibold text-foreground truncate text-sm md:text-base">
                  {post?.author}
                </h2>
              </div>
              <p className="caption text-muted-foreground truncate">
                @{post?.username}
              </p>
            </div>
          </button>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          {!post?.isOwnPost && (
            <Button
              variant={isFollowing ? "outline" : "default"}
              size="sm"
              onClick={onFollowToggle}
              className="hidden md:flex"
            >
              {isFollowing ? "Following" : "Follow"}
            </Button>
          )}

          <button
            className="touch-target flex items-center justify-center text-muted-foreground hover:text-foreground transition-base"
            aria-label="More options"
          >
            <Icon name="MoreVertical" size={24} />
          </button>
        </div>
      </div>
      {!post?.isOwnPost && (
        <div className="px-4 pb-4 md:hidden">
          <Button
            variant={isFollowing ? "outline" : "default"}
            size="sm"
            onClick={onFollowToggle}
            fullWidth
          >
            {isFollowing ? "Following" : "Follow"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default PostHeader;